import classNames from 'classnames';
import PageSectionType from '@alltrails/amplitude/enums/PageSectionType';
import { ErrorBoundary } from '@alltrails/stability';
import SectionNavId from '@/utils/SectionNavId';
import Divider from '../Divider/Divider';
import styles from './PageSection.module.scss';
import SectionViewedHandler from './SectionViewedHandler';

type PageSectionProps = {
  children: React.ReactNode;
  containerClassName?: string;
  hasDividerTop?: boolean;
  hideXOverflow?: boolean;
  id?: SectionNavId;
  sectionType?: PageSectionType;
};

const PageSection = ({ hasDividerTop = true, hideXOverflow, containerClassName, children, id, sectionType }: PageSectionProps) => {
  const pageSectionWithMargins = (
    <>
      {hasDividerTop && <Divider />}
      <SectionViewedHandler
        className={classNames(styles.container, containerClassName, {
          [styles.scrollMarginSm]: hideXOverflow
        })}
        id={id}
        observerOptions={{ threshold: 0.2 }}
        sectionType={sectionType}
      >
        {hasDividerTop && hideXOverflow && <div className={styles.dividerPadding} />}
        {children}
      </SectionViewedHandler>
    </>
  );

  if (hideXOverflow) {
    return (
      <ErrorBoundary>
        <div className={styles.hideXOverflow}>{pageSectionWithMargins}</div>{' '}
      </ErrorBoundary>
    );
  }

  return <ErrorBoundary>{pageSectionWithMargins}</ErrorBoundary>;
};

export default PageSection;
